var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var mutations = {
    landingPagesRetrieved: function (state, payload) {
        var _a, _b;
        state.pages = __assign(__assign({}, state.pages), (_a = {}, _a[payload.jobId] = payload.pages, _a));
        state.loading = __assign(__assign({}, state.loading), (_b = {}, _b[payload.jobId] = false, _b));
    },
    retrievingLandingPages: function (state, payload) {
        var _a;
        state.loading = __assign(__assign({}, state.loading), (_a = {}, _a[payload.jobId] = true, _a));
    },
    landingPageUpdated: function (state, payload) {
        var _a;
        var page = state.pages[payload.jobId].find(function (page) { return page.id === payload.landingPage.id; });
        page.name = payload.landingPage.name;
        page.slug = payload.landingPage.slug;
        page.content = payload.landingPage.content;
        page.locale = payload.landingPage.locale;
        page.appearance.heroImage = payload.landingPage.appearance.heroImage;
        page.appearance.logo = payload.landingPage.appearance.logo;
        state.pages = __assign(__assign({}, state.pages), (_a = {}, _a[payload.jobId] = state.pages[payload.jobId], _a));
    },
    landingPageDeleted: function (state, payload) {
        var _a;
        state.pages = __assign(__assign({}, state.pages), (_a = {}, _a[payload.jobId] = payload.pages.filter(function (page) { return page.id !== payload.landingPageId; }), _a));
    },
    landingPagePublished: function (state, payload) {
        var _a;
        state.pages[payload.jobId].find(function (page) { return page.id === payload.landingPageId; }).isPublished = true;
        state.pages = __assign(__assign({}, state.pages), (_a = {}, _a[payload.jobId] = state.pages[payload.jobId], _a));
    },
    landingPageUnpublished: function (state, payload) {
        state.pages[payload.jobId].find(function (page) { return page.id === payload.landingPageId; }).isPublished = false;
        state.pages = __assign({}, state.pages);
    },
    jobListLinked: function (state, payload) {
        var _a;
        if (state.pages[payload.jobId]) {
            state.pages[payload.jobId].find(function (page) { return page.id === payload.landingPageId; }).jobLists = payload.jobLists;
        }
        state.pages = __assign(__assign({}, state.pages), (_a = {}, _a[payload.jobId] = state.pages[payload.jobId], _a));
    },
};
export var types = {
    LANDING_PAGES_RETRIEVED: 'landingPagesRetrieved',
    LANDING_PAGES_RETRIEVING: 'retrievingLandingPages',
    LANDING_PAGE_UPDATED: 'landingPageUpdated',
    LANDING_PAGE_RETRIEVING: 'retrievingLandingPage',
    LANDING_PAGE_RETRIEVED: 'landingPageRetrieved',
    LANDING_PAGE_DELETED: 'landingPageDeleted',
    LANDING_PAGE_PUBLISHED: 'landingPagePublished',
    LANDING_PAGE_UNPUBLISHED: 'landingPageUnpublished',
    JOB_LIST_LINKED: 'jobListLinked',
};
